// TODO: Replace the existing getCookie util (getcookie.js) with the below and test all implementations
// /**
//  * Retrieves a cookie value by its name
//  * @param {string} name - The name of the cookie to retrieve
//  * @returns {string|null} The decoded cookie value if found, null otherwise
//  */
// const getCookie = (name) => {
//     const match = document.cookie.match(new RegExp('(^| )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]+)'))
//     return match ? decodeURIComponent(match[2]) : null
// }

/**
 * Sets a cookie with the specified name, value, and options
 * @param {string} name - The name of the cookie
 * @param {string} value - The value to store in the cookie
 * @param {Object} [options={}] - Cookie options
 * @param {string} [options.path='/'] - The cookie path
 * @param {number|Date} [options.expires] - Expiration time in days or Date object
 * @param {string} [options.sameSite='Lax'] - SameSite attribute value
 * @param {boolean} [options.secure=false] - Whether the cookie should be secure
 */
const setCookie = (name, value, options = {}) => {
	const {
		path = '/',
		expires, // number (days) or Date
		sameSite = 'Lax',
		secure = false,
	} = options

	let cookieStr = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`

	if (expires) {
		const expiryDate =
			typeof expires === 'number' ? new Date(Date.now() + expires * 864e5) : expires
		cookieStr += `; expires=${expiryDate.toUTCString()}`
	}

	if (path) cookieStr += `; path=${path}`
	if (sameSite) cookieStr += `; SameSite=${sameSite}`
	if (secure) cookieStr += `; Secure`

	document.cookie = cookieStr
}

/**
 * Deletes a cookie with the specified name
 * @param {string} name - The name of the cookie to delete
 * @param {string} [path='/'] - The path of the cookie to delete
 */
const deleteCookie = (name, path = '/') => {
	document.cookie = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}`
}

export {setCookie, deleteCookie}
